module.exports = __webpack_public_path__ + "img/tz_niu1.f0165d43.png";